const Reloader = () => {
    return (
        <div class="loader"></div>
    )
}

export default Reloader;